<template>
	<vx-card class="ticket-payment-info">
		<SetStageChangePopup
			:active.sync="changePopupActive"
			:isEditMode="isEditMode"
			:stage.sync="stageItemForChange"
			@confirm="setStageChanged"
		/>

		<SetStageFailedPopup
			:active.sync="failedPopupActive"
			:notNotifyClient.sync="notNotifyClient"
			:recommendedPrice="priceForAuthor"
      :loading="isLoading"
			@confirm="setStageFailed"
		/>

		<SetStageDonePopup
			:active.sync="donePopupActive"
			:notNotifyClient.sync="notNotifyClient"
			:recommendedPrice="priceForAuthor"
			:currentStage="currentStage"
			:isLastStage="isLastStage"
      :loading="isLoading"
			@confirm="setStageDone"
		/>

		<ConfirmManuallyPayment
			:active.sync="confirmPopupState"
			:amount="manuallyConfirmationPrice"
			@confirm="setConfirmPaymentManually"
		/>

		<ConfirmMarginalityAction
			:active.sync="marginalityPopupState"
			@confirm="confirmStageWithLowMarginality"
			@cancel="marginalityPopupState = false"
		/>

		<OrderPriceIncorrectModal
			:active.sync="priceIncorrectPopupState"
			@confirm="confirmOrderWithIncorrectPrice"
			@cancel="priceIncorrectPopupState = false"
		/>

		<b>{{ $t("paymentDetails") }}</b>
		<div class="stages">
			<div
				v-for="(stage, index) in stages"
				:key="stage.id"
				class="stage"
				:class="{ not_paid: stage.completed_payment === 0 }"
			>
				<div class="head">
					<span class="stage__title">
						<div class="stage__title-text">
							{{ $t("stage") }} {{ index + 1 }}
						</div>

						<div
							v-if="
								stage.marginality_correct === false &&
									showMarginality(stage)
							"
							class="stage__title-marginality status-warn"
						>
							{{ $t("marginality") }} {{ stage.marginality }}%
						</div>
					</span>

					<div class="vx-row align-center">
						<!-- <div v-if="(userRole === 'admin' || canManageStage(stage)) && isReadOnly" class="vx-col mb-2">
							<vs-button
								@click="changePopupStatus(stage)"
								class="stage__control"
								color="warning"
							>{{ $t('changePrice') }}</vs-button>
						</div> -->

						<div
							v-if="
								canShowNotDoneButton(stage, index) && isReadOnly
							"
							class="vx-col mb-2"
						>
							<vs-button
								@click="setFailedPopupState"
								class="stage__control"
								color="danger"
								>{{ $t("notDone") }}</vs-button
							>
						</div>

						<div
							v-if="canManageStage(stage) && isReadOnly"
							class="vx-col mb-2"
						>
							<vs-button
								@click="donePopupActive = true"
								class="stage__control"
								color="success"
								>{{ $t("done") }}</vs-button
							>
						</div>

						<div
							v-if="canShowStageStatus(stage) && isReadOnly"
							class="vx-col mb-2"
						>
							<span
								:class="
									`${$getStatusColor(stage.status)} status`
								"
								>{{ $getStatus(stage.status) }}</span
							>
						</div>
					</div>

					<span
						v-if="index !== 0 && !isReadOnly"
						@click="removeStage(stage.id)"
						class="cursor-pointer"
					>
						<svg
							width="25"
							height="25"
							x="0"
							y="0"
							class="stencil--easier-to-select"
							style="opacity: 1;"
						>
							<defs></defs>
							<rect
								x="0"
								y="0"
								width="25"
								height="25"
								fill="transparent"
								class="stencil__selection-helper"
							></rect>
							<path
								d="M9.093319194061507 9.90038872691934C9.093319194061507 9.90038872691934 9.093319194061507 19.26627793974733 9.093319194061507 19.26627793974733 9.093319194061506 19.420149011985746 9.040296924708379 19.545675413022348 8.934252386002122 19.642857142857142 8.828207847295864 19.740038872691926 8.69123365146695 19.788629737609327 8.523329798515377 19.78862973760933 8.523329798515377 19.78862973760933 7.383351007423118 19.78862973760933 7.383351007423118 19.78862973760933 7.215447154471545 19.78862973760933 7.07847295864263 19.740038872691937 6.9724284199363735 19.642857142857142 6.866383881230116 19.545675413022348 6.813361611876989 19.420149011985746 6.813361611876989 19.26627793974733 6.813361611876989 19.26627793974733 6.813361611876989 9.90038872691934 6.813361611876989 9.90038872691934 6.813361611876989 9.74651765468092 6.866383881230116 9.620991253644315 6.9724284199363735 9.523809523809526 7.07847295864263 9.426627793974735 7.215447154471545 9.378036929057338 7.383351007423118 9.378036929057338 7.383351007423118 9.378036929057338 8.523329798515377 9.378036929057338 8.523329798515377 9.378036929057338 8.69123365146695 9.378036929057338 8.828207847295864 9.426627793974733 8.934252386002122 9.523809523809526 9.040296924708379 9.620991253644318 9.093319194061506 9.746517654680922 9.093319194061507 9.90038872691934 9.093319194061507 9.90038872691934 9.093319194061507 9.90038872691934 9.093319194061507 9.90038872691934M13.639978791092258 9.90038872691934C13.639978791092258 9.90038872691934 13.639978791092258 19.26627793974733 13.639978791092258 19.26627793974733 13.639978791092258 19.420149011985746 13.58695652173913 19.545675413022348 13.480911983032875 19.642857142857142 13.374867444326618 19.740038872691926 13.237893248497702 19.788629737609327 13.069989395546129 19.78862973760933 13.069989395546129 19.78862973760933 11.930010604453871 19.78862973760933 11.930010604453871 19.78862973760933 11.762106751502298 19.78862973760933 11.625132555673384 19.740038872691937 11.519088016967126 19.642857142857142 11.41304347826087 19.545675413022348 11.36002120890774 19.420149011985746 11.360021208907742 19.26627793974733 11.360021208907742 19.26627793974733 11.360021208907742 9.90038872691934 11.360021208907742 9.90038872691934 11.360021208907742 9.74651765468092 11.41304347826087 9.620991253644315 11.519088016967126 9.523809523809526 11.625132555673384 9.426627793974735 11.762106751502296 9.378036929057338 11.930010604453871 9.378036929057338 11.930010604453871 9.378036929057338 13.069989395546129 9.378036929057338 13.069989395546129 9.378036929057338 13.229056203605513 9.378036929057338 13.366030399434429 9.426627793974733 13.480911983032875 9.523809523809526 13.59579356663132 9.620991253644318 13.648815835984449 9.746517654680922 13.639978791092258 9.90038872691934 13.639978791092258 9.90038872691934 13.639978791092258 9.90038872691934 13.639978791092258 9.90038872691934M18.17338282078473 9.90038872691934C18.17338282078473 9.90038872691934 18.17338282078473 19.26627793974733 18.17338282078473 19.26627793974733 18.17338282078473 19.420149011985746 18.120360551431602 19.545675413022348 18.014316012725345 19.642857142857142 17.908271474019088 19.740038872691926 17.775715800636267 19.788629737609327 17.61664899257688 19.78862973760933 17.61664899257688 19.78862973760933 16.476670201484623 19.78862973760933 16.476670201484623 19.78862973760933 16.30876634853305 19.78862973760933 16.171792152704136 19.740038872691937 16.06574761399788 19.642857142857142 15.95970307529162 19.545675413022348 15.906680805938493 19.420149011985746 15.906680805938496 19.26627793974733 15.906680805938496 19.26627793974733 15.906680805938496 9.90038872691934 15.906680805938496 9.90038872691934 15.906680805938496 9.74651765468092 15.959703075291623 9.620991253644315 16.06574761399788 9.523809523809526 16.171792152704132 9.426627793974735 16.308766348533048 9.378036929057338 16.476670201484623 9.378036929057338 16.476670201484623 9.378036929057338 17.61664899257688 9.378036929057338 17.61664899257688 9.378036929057338 17.77571580063627 9.378036929057338 17.908271474019088 9.426627793974733 18.014316012725345 9.523809523809526 18.1203605514316 9.620991253644318 18.17338282078473 9.746517654680922 18.17338282078473 9.90038872691934 18.17338282078473 9.90038872691934 18.17338282078473 9.90038872691934 18.17338282078473 9.90038872691934M20.453340402969246 21.67152575315841C20.453340402969246 21.67152575315841 20.453340402969246 6.256073858114675 20.453340402969246 6.256073858114675 20.453340402969246 6.256073858114675 4.546659597030754 6.256073858114675 4.546659597030754 6.256073858114675 4.546659597030754 6.256073858114675 4.546659597030754 21.67152575315841 4.546659597030754 21.67152575315841 4.546659597030753 21.914480077745385 4.586426299045599 22.13718820861678 4.665959703075292 22.339650145772598 4.745493107104984 22.54211208292841 4.833863556026865 22.687884677680596 4.931071049840933 22.77696793002916 5.028278543655003 22.866051182377714 5.090137857900319 22.910592808551993 5.1166489925768825 22.910592808551993 5.1166489925768825 22.910592808551993 19.88335100742312 22.910592808551993 19.88335100742312 22.910592808551993 19.91869918699187 22.910592808551993 19.980558501237187 22.866051182377714 20.06892895015907 22.77696793002916 20.157299399080948 22.687884677680596 20.241251325556735 22.54211208292841 20.32078472958643 22.339650145772598 20.400318133616118 22.13718820861678 20.444503358077057 21.914480077745385 20.453340402969246 21.67152575315841 20.453340402969246 21.67152575315841 20.453340402969246 21.67152575315841 20.453340402969246 21.67152575315841M8.523329798515377 4.166666666666666C8.523329798515377 4.166666666666666 16.476670201484623 4.166666666666666 16.476670201484623 4.166666666666666 16.476670201484623 4.166666666666666 15.628313891834571 2.271622934888241 15.628313891834571 2.271622934888241 15.53994344291269 2.17444120505345 15.438317426652528 2.1137026239067063 15.323435843054085 2.0894071914480077 15.323435843054085 2.0894071914480077 9.689819724284199 2.0894071914480077 9.689819724284199 2.0894071914480077 9.574938140685754 2.1137026239067063 9.473312124425593 2.17444120505345 9.384941675503713 2.271622934888241 9.384941675503713 2.271622934888241 8.523329798515377 4.166666666666666 8.523329798515377 4.166666666666666M25 4.689018464528669C25 4.689018464528669 25 5.733722060252672 25 5.733722060252672 25 5.887593132491093 24.946977730646875 6.013119533527698 24.840933191940614 6.110301263362489 24.734888653234357 6.20748299319728 24.597914457405444 6.256073858114675 24.430010604453873 6.256073858114675 24.430010604453873 6.256073858114675 22.720042417815485 6.256073858114675 22.720042417815485 6.256073858114675 22.720042417815485 6.256073858114675 22.720042417815485 21.67152575315841 22.720042417815485 21.67152575315841 22.720042417815485 22.57855523161646 22.44167550371156 23.360058309037903 21.884941675503715 24.016034985422742 21.32820784729587 24.67201166180758 20.66101095793567 25 19.88335100742312 25 19.88335100742312 25 5.1166489925768825 25 5.1166489925768825 25 4.330151997172146 25 3.658536585365854 24.68011013929381 3.1018027571580062 24.04033041788144 2.5450689289501587 23.400550696469065 2.266702014846235 22.635244574020085 2.2667020148462353 21.7444120505345 2.2667020148462353 21.7444120505345 2.2667020148462353 6.256073858114675 2.2667020148462353 6.256073858114675 2.2667020148462353 6.256073858114675 0.5699893955461294 6.256073858114675 0.5699893955461294 6.256073858114675 0.40208554259455637 6.256073858114675 0.2651113467656415 6.20748299319728 0.15906680805938495 6.110301263362489 0.05302226935312831 6.013119533527698 0 5.887593132491093 0 5.733722060252672 0 5.733722060252672 0 4.689018464528669 0 4.689018464528669 0 4.53514739229025 0.05302226935312831 4.409620991253645 0.15906680805938495 4.312439261418854 0.2651113467656415 4.2152575315840615 0.40208554259455637 4.166666666666666 0.5699893955461294 4.166666666666666 0.5699893955461294 4.166666666666666 6.057794273594911 4.166666666666666 6.057794273594911 4.166666666666666 6.057794273594911 4.166666666666666 7.290562036055143 1.4577259475218662 7.290562036055143 1.4577259475218662 7.4761399787910925 1.0528020732102363 7.798692117355956 0.7086167800453516 8.258218451749736 0.425170068027211 8.717744786143514 0.14172335600907005 9.18610816542948 0 9.663308589607636 0 9.663308589607636 0 15.336691410392365 0 15.336691410392365 0 15.813891834570521 0 16.282255213856484 0.14172335600907005 16.741781548250266 0.425170068027211 17.201307882644045 0.7086167800453516 17.519441498762816 1.0528020732102363 17.696182396606577 1.4577259475218662 17.696182396606577 1.4577259475218662 18.94220572640509 4.166666666666666 18.94220572640509 4.166666666666666 18.94220572640509 4.166666666666666 24.430010604453873 4.166666666666666 24.430010604453873 4.166666666666666 24.597914457405444 4.166666666666666 24.73488865323436 4.2152575315840615 24.840933191940614 4.312439261418854 24.946977730646868 4.409620991253645 24.999999999999996 4.53514739229025 25 4.689018464528669 25 4.689018464528669 25 4.689018464528669 25 4.689018464528669"
								stroke-width="0"
								stroke="none"
								stroke-dasharray="none"
								fill="rgb(234, 84, 85)"
								fill-rule="evenOdd"
							></path>
						</svg>
					</span>
				</div>
				<div class="vx-row stage-list">
					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<vs-input
							v-model="stage.price_client"
							:disabled="
								!isNewStageInEditMode(stage) &&
									isReadOnly &&
									!isEditMode
							"
							:label="$t('priceForClient')"
							ref="price"
							@input="
								updateStage(stage, index, stage.price_client)
							"
						/>
					</div>
					<div
						v-if="
							author &&
								(author.quality_level === 1 ||
									author.quality_level_id === 1)
						"
						class="vx-col sm:w-1/3 w-1/2 stage-list__item"
					>
						<vs-input
							v-model="stage.price_native"
							:disabled="
								!isNewStageInEditMode(stage) &&
									disableEditFieldForManager(stage)
							"
							:label="$t('priceForNative')"
							@input="
								updateStage(stage, index, stage.price_native)
							"
						/>
					</div>
					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<vs-input
							v-model="stage.price_junior_middle"
							:disabled="
								!isNewStageInEditMode(stage) &&
									disableEditFieldForManager(stage)
							"
							:label="$t('priceForJuniorAndMiddle')"
							ref="price"
							@input="
								updateStage(
									stage,
									index,
									stage.price_junior_middle
								)
							"
						/>
					</div>
					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<vs-input
							:disabled="
								!isNewStageInEditMode(stage) &&
									disableEditFieldForManager(stage)
							"
							:label="$t('priceForSenior')"
							v-model="stage.price_senior"
							@input="
								updateStage(stage, index, stage.price_senior)
							"
						/>
					</div>
					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<vs-input
							:disabled="
								!isNewStageInEditMode(stage) &&
									disableEditFieldForManager(stage)
							"
							:label="$t('pagesAmountShort')"
							v-model="stage.pages_number"
							v-validate="'required|decimal:2'"
							@input="updateStage(stage, index)"
							type="number"
							step="0.5"
						/>
					</div>

					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<label class="vs-input--label">{{
								$t("workType")
							}}</label>
							<v-select
								v-model="stage.work_type_id"
								v-validate="'required'"
								:clearable="false"
								:reduce="work => work.id"
								:options="works"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="
									!isNewStageInEditMode(stage) && isReadOnly
								"
								@input="recalcPriceAndChangeStage(stage, index)"
								name="work"
								label="name"
								class="single-row-select"
							/>
						</div>
					</div>
					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<div class="vs-component vs-con-input-label vs-input vs-input-primary">
							<label class="vs-input--label">{{ $t("dueDate") }}</label>
							<vs-datepicker
								v-model="stage.due_date"
								:disabled="isReadOnly && !isEditMode"
								class="date-picker"
								format="dd.MM.yyyy"
								@change="handleDueDateChange(stage)"
							/>
						</div>
					</div>

					<div class="vx-col sm:w-1/3 w-1/2 stage-list__item">
						<div v-if="stage.show_reschedule_reason" class="vs-component vs-con-input-label vs-input vs-input-primary"">
							<label class="vs-input--label">{{ $t("rescheduleReason") }}</label>
							<v-select
								:options="rescheduleReasons"
								v-model="stage.reschedule_reason"
								label="name"
								name="rescheduleReasons"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:clearable="true"
								placeholder="Select reason"
								class="w-full"
								v-validate="'required'"
								@input="saveStageChanges(stage)"
							/>
							<span class="reschedule-warning" style="color: red">
									{{ $t("requiredField") }}
							</span>
						</div>
					</div>
				</div>
				<vs-alert v-if="showAuthorDeadline" color="primary" class="mt-2" >
					<b>{{ $t("authorDeadline") }}:</b>
					{{ stage.author_deadline }}
				</vs-alert>

				<vs-alert v-if="showRescheduleReason(stage)" color="warning" class="mt-2">
					<b>{{ $t("rescheduleReason") }}:</b>
					{{ getRescheduleReasonName(stage.reschedule_reason) }}
				</vs-alert>
				<vs-alert v-if="stage.done_by_author_type && !isEditMode" color="primary" class="mt-2" >
					<b>{{ publicType(stage.done_by_author_type.type) }}:</b>
					<router-link :to="'/author/' + stage.done_by_author_type.id" v-if="role === 'admin'">
						{{ stage.done_by_author_type.first_name }} {{ stage.done_by_author_type.last_name }}

					</router-link>

					<router-link :to="'/authorM/' + stage.done_by_author_type.id" v-if="role === 'manager'">
						{{ stage.done_by_author_type.first_name }} {{ stage.done_by_author_type.last_name }}
					</router-link>
				</vs-alert>
				<div v-if="author && isEditMode" class="mt-4">
					<label class="vs-input--label">{{ $t("changeStageAuthor") }}</label>
					<div color="primary" class=" flex justify-between">
						<!-- тип -->
						<v-select
							:options="authorType"
							v-model="stage._authorType"
							label="name"
							placeholder="Select author type"
							class="w-1/2 mr-2"
							:clearable="true"
							@input="onStageAuthorTypeInput(stage)"
						/>

						<!-- автор -->
						<v-select
							:options="stage._authorsOptions || []"
							v-model="stage._authorId"
							:reduce="a => a.id"
							label="full_name"
							placeholder="Select author"
							class="w-1/2"
							:clearable="true"
							:disabled="!stage._authorType"
							@input="onStageAuthorInput(stage)"
						/>

					</div>
				</div>

			<div class="vx-row">
					<div
						v-if="stage.invoices && stage.invoices.length !== 0"
						class="vx-col"
					>
						<div class="vx-row">
							<div
								v-for="(item, index) in stage.invoices"
								:key="index"
								class="vx-col"
							>
								<!-- <a :href="item.fullUrl || item.url" class="stage__invoice">
									<img :src="item.fullUrl || item.url">
								</a> -->
								<div
									@click="e => openImagePopup(e, item)"
									class="stage__invoice"
								>
									<img :src="item.fullUrl || item.url" />
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="canShowUpload(stage)"
						class="vx-col flex flex-col w-full mt-6"
					>
						<vs-upload
							v-if="isReadOnly"
							:show-upload-button="false"
							accept=".jpg,.jpeg,.png"
							:text="$t('loadPhoto')"
							@change="addPaymentPhotos"
							@on-delete="deletePaymentPhoto"
						/>

						<div class="flex">
							<span
								v-if="paymentPhotos.length !== 0"
								class="status status-ok cursor-pointer"
								@click="confirmStagePayment(stage.id)"
								>{{ $t("confirmPayment") }}</span
							>
						</div>
					</div>
					<div
						v-if="
							stage.completed_payment === 0 &&
								userRole === 'admin'
						"
						class="vx-col mt-4  w-full"
					>
						<span
							class="status status-ok cursor-pointer manual-payout"
							@click="setStageConfirmPaymentManually(stage)"
							>{{ $t("confirmPaymentManually") }}</span
						>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3 flex-wrap">
			<div class="stage-info vx-row">
				<div class="vx-col mb-4">
					<span>
						{{ $t("recommendedPaymentSum") }}:
						<b>{{ recommendedPrice }} €</b> </span
					><br />
					<span class="d-flex align-center"
						>{{ $t("totalPaymentSum") }}:
						<b class="ml-1">{{ totalSum }} €</b>
						<span class="ml-3" v-if="recommendedPrice > totalSum">
							<vs-tooltip :text="$t('lowerThanRecommendedSum')">
								<vs-input-number style="display: none" />
								<svg
									width="24"
									height="21"
									x="0"
									y="0"
									class="stencil--easier-to-select"
									style="opacity: 1;"
								>
									<defs></defs>
									<rect
										x="0"
										y="0"
										width="24"
										height="21"
										fill="transparent"
										class="stencil__selection-helper"
									></rect>
									<path
										d="M12 0C12 0 0 21.000000000000004 0 21.000000000000004 0 21.000000000000004 24 21.000000000000004 24 21.000000000000004M12 4.421052631578947C12 4.421052631578947 20.214545454545455 18.78947368421053 20.214545454545455 18.78947368421053 20.214545454545455 18.78947368421053 3.785454545454545 18.78947368421053 3.785454545454545 18.78947368421053M10.90909090909091 8.842105263157896C10.90909090909091 8.842105263157896 10.90909090909091 13.263157894736842 10.90909090909091 13.263157894736842 10.90909090909091 13.263157894736842 13.09090909090909 13.263157894736842 13.09090909090909 13.263157894736842 13.09090909090909 13.263157894736842 13.09090909090909 8.842105263157896 13.09090909090909 8.842105263157896M10.90909090909091 15.473684210526317C10.90909090909091 15.473684210526317 10.90909090909091 17.68421052631579 10.90909090909091 17.68421052631579 10.90909090909091 17.68421052631579 13.09090909090909 17.68421052631579 13.09090909090909 17.68421052631579 13.09090909090909 17.68421052631579 13.09090909090909 15.473684210526317 13.09090909090909 15.473684210526317"
										stroke-width="0"
										stroke="none"
										stroke-dasharray="none"
										fill="rgb(234, 84, 85)"
										fill-rule="evenOdd"
									></path>
								</svg>
							</vs-tooltip>
						</span>
					</span>
					<span>
						{{ $t("amountOfIncome") }}:
						<b>{{ amountOfIncome }} €</b> </span
					><br />
				</div>
				<div v-if="!hideAddStageButton" class="vx-col">
					<vs-button @click="addStage">{{
						$t("addStage")
					}}</vs-button>
				</div>
			</div>

			<template v-if="!isReadOnly">
				<vs-button
					:disabled="isLoading"
					class="mr-3 mt-4"
					@click="sendOrderApproval"
					>{{ $t("sendForApproval") }}</vs-button
				>
			</template>

			<template v-if="status === 'waiting_payment' && noPaidStage">
				<vs-button
					v-if="!isEditClicked"
					@click="enableEditing"
					class="mr-2 mt-4"
					>{{ $t("edit") }}</vs-button
				>

				<vs-button v-else disabled class="mr-2 mt-4">{{
					$t("edit")
				}}</vs-button>
			</template>

			<template v-if="!isReadOnly">
				<vs-button
					:disabled="isLoading"
					color="success"
					class="mt-4"
					@click="checkMarginalityBeforeConfirmOrder"
					>{{ $t("approve") }}</vs-button
				>
			</template>
		</div>
	</vx-card>
</template>

<script>
import SetStageFailedPopup from "@/components/dialogs/SetStageFailedPopup";
import SetStageDonePopup from "@/components/dialogs/SetStageDonePopup";
import vSelect from "vue-select";
import moment from "moment";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import SetStageChangePopup from "@/components/dialogs/SetStageChangePopup.vue";
import ConfirmMarginalityAction from "@/components/dialogs/ConfirmMarginalityAction.vue";
import OrderPriceIncorrectModal from "@/components/dialogs/OrderPriceIncorrectModal.vue";
import debounce from "debounce";
import ConfirmManuallyPayment from "@/components/dialogs/ConfirmManuallyPayment.vue";

export default {
	name: "CardStages",
	mixins: [databaseManager, notifier],
	props: {
		orderId: { default: -1, type: Number },
		stages: { type: Array, default: () => [], required: true },
		status: { default: "new", type: String },
		works: { type: Array, default: () => [] },
		author: { default: null, required: true },
		isEditMode: { type: Boolean, default: false },
		enableWorkTypesList: { type: Array, default: () => [] },
		currentSubject: { type: Object, default: () => ({}) },
		amountOfIncome: { type: Number, default: 0 },
		isMarginalityLow: { default: false },
		inputHasChanged: { default: false },
		isPriceIncorrect: { default: false },
		authors: [],
	},

	components: {
		SetStageFailedPopup,
		SetStageDonePopup,
		vSelect,
		SetStageChangePopup,
		ConfirmMarginalityAction,
		OrderPriceIncorrectModal,
		ConfirmManuallyPayment
	},

	data() {
		return {
			recommendedPrice: 0,
			changePopupActive: false,
			failedPopupActive: false,
			donePopupActive: false,
			updateTimeout: null,
			stagesUpdatingList: new Set(),
			paymentPhotos: [],
			isNotUploadingPayment: true,
			isLoading: false,

			isSendForApprovalClicked: false,
			isApproveClicked: false,
			isEditClicked: false,
			isUpdatingAuthor: true,

			stageItemForChange: null,

			imagePopupActive: false,
			imagePopupFile: null,
			confirmPopupState: false,
			stageForCompletePaymentManually: null,

			marginalityPopupState: false,
			isMarginalityTaskCreated: false,
			confirmationFunction: "",

			priceIncorrectPopupState: false,
			isPriceIncorrectTaskCreated: false,

      		notNotifyClient: false,

			reschedule_reason: '',
			rescheduleValidationError: false,
			type: '',
			authorsByTypeCache: {},
		};
	},

	created() {
		this.stages = this.stages.map(stage => ({
			...stage,
			due_date_original: stage.due_date,
			show_reschedule_reason: false,
		}));
	},
	watch: {
		isPriceIncorrect(newVal) {
			if (newVal) {
				this.isPriceIncorrectTaskCreated = false;
			}
		},

		orderId() {
			this.updateRecommendedPrice();
		},

		author(val) {
			this.isUpdatingAuthor = false;
			this.isNativeAuthor = val;
			if (val) {
				this.checkIsNativeAuthorHasPrice();
			}
		},

		donePopupActive(value) {
			if (!value) return;

			this.isUpdatingAuthor = true;
			this.$emit("updateAuthor");
		},

		isEditMode: {
			immediate: true,
			async handler(newVal) {
				this.$emit("update:inputHasChanged", false);

				if (!newVal) {
					// Leaving edit mode: keep cached data, just reset the "dirty" marker.
					for (const stage of this.stages || []) {
						if (stage && typeof stage === "object") {
							this.$set(stage, "_authorDirty", false);
						}
					}
					return;
				}

				// Entering edit mode: initialize per-stage author controls from existing stage data.
				for (const stage of this.stages || []) {
					if (!stage || typeof stage !== "object") continue;

					var existingTypeValue = stage.done_by_author_type && stage.done_by_author_type.type
						? stage.done_by_author_type.type
						: null;
					var existingAuthorId = null;

					if (stage.done_by_author_type && stage.done_by_author_type.id) {
						existingAuthorId = stage.done_by_author_type.id;
					} else if (stage.done_by_author_type_id) {
						existingAuthorId = stage.done_by_author_type_id;
					}

					const typeObj = existingTypeValue
						? this.authorType.find(t => t.value === existingTypeValue) || null
						: null;

					this.$set(stage, "_authorType", typeObj);
					this.$set(stage, "_authorId", existingAuthorId);
					this.$set(stage, "_authorDirty", false);

					if (!typeObj) {
						this.$set(stage, "_authorsOptions", []);
						continue;
					}

					const options = await this.getAuthorsOptionsByTypeValue(typeObj.value);
					this.$set(stage, "_authorsOptions", options);
				}
			},
		},
	},

	computed: {
		role() {
			return this.$store.state.auth.role
		},
		rescheduleReasons() {
			return [
				{
					name: this.$t('authorRequest'),
					value: 'author_request',
				},
				{
					name: this.$t('noAuthorResponse'),
					value: 'no_author_response',
				},
				{
					name: this.$t('clientRequest'),
					value: 'client_request',
				},
				{
					name: this.$t('noClientResponse'),
					value: 'no_client_response',
				},
				{
					name: this.$t('orderUnderQaReview'),
					value: 'order_under_qa_review',
				},
				{
					name: this.$t('delayedCustomerPayment'),
					value: 'delayed_customer_payment',
				},
				{
					name: this.$t('revisionsDelayedDeadline'),
					value: 'revisions_delayed_deadline',
				},
				{
					name: this.$t('shortTaskDeadline'),
					value: 'short_task_deadline',
				},
				{
					name: this.$t('other'),
					value: 'other',
				},
			];
		},
		authorType() {
			return [
				{
					name: 'Author',
					value: 'author',
				},
				{
					name: 'KI-author',
					value: 'ki-author',
				},
			];
		},
		lowMargStage() {
			if (this.stages && this.stages.length) {
				const lowMargStage = this.stages.find(
					el => el.marginality_correct === false
				);

				return !!lowMargStage;
			}
			return false;
		},

		hasUnsavedStage() {
			return this.stages.some(stage => stage.id === undefined);
		},

		hideAddStageButton() {
			if (this.hasUnsavedStage) return true;
			if (!this.isReadOnly) return false;
			if (this.isEditMode && !this.failedStages && !this.noPaidStage)
				return false;
			return true;
		},

		isNativeAuthor: {
			get() {
				if (
					this.author &&
					(this.author.quality_level === 1 ||
						this.author.quality_level_id === 1)
				) {
					return this.author.native_page_price;
				}

				return false;
			},
			set(val) {
				this.author = val;
			}
		},

		userRole() {
			return this.$store.state.auth.role;
		},

		priceForAuthor() {
			if (!this.author || !this.currentStage) return "...";
      const qualityLevel = this.author.quality_level
      const qualityLevelId = this.author.quality_level_id

			if (qualityLevel === 1) {
				return this.currentStage.price_native;
			} else if (
        qualityLevel === 2 ||
        qualityLevelId === 2 ||
        qualityLevel === 4 ||
        qualityLevelId === 4
      ) {
				return this.currentStage.price_junior_middle;
			} else {
				return this.currentStage.price_senior;
			}
		},

		minDate() {
			return new Date();
		},
		showAuthorDeadline() {
			if (
				this.status === "new" ||
				this.status === "client_not_answer" ||
				this.status === "offer_sent" ||
				this.status === "work_long_term" ||
				this.status === "processing"
			)
				return false;

			if(this.stages.length === 0)
				return false;

			if(this.stages[0].status === 'waiting_payment' || this.stages[0].status === 'new')
				return false;

			return true;
		},
		isReadOnly() {
			if (
				this.status === "new" ||
				this.status === "client_not_answer" ||
				this.status === "offer_sent" ||
				this.status === "work_long_term" ||
				this.status === "processing"
			)
				return false;

			return true;
		},
		isForRecheduleReason() {
			if (
				this.status === "waiting_payment" ||
				this.status === "waiting_author" ||
				this.status === "in_progress" ||
				this.status === "waiting_approve"
			)
				return true;
			return false;
		},

		totalSum() {
			const total = this.stages.reduce((acc, el) => {
				return acc + Number(el.price_client);
			}, 0);

			return Math.round(total);
		},

		currentStage() {
			let current = null;

			for (let item of this.stages) {
				if (
					item.status === "failed_with_payout" ||
					item.status === "failed"
				) {
					break;
				}

				if (item.status !== "completed") {
					current = item;
					break;
				}
			}

			return current !== -1 ? current : null;
		},

		isLastStage() {
			if (!this.currentStage || !Array.isArray(this.stages) || !this.stages.length) {
				return false
			}

			const currentStageIdx = this.stages.findIndex((el) => el.id === this.currentStage.id)
			const lastIdx = this.stages.length

			return currentStageIdx + 1 === lastIdx
		},

		noPaidStage() {
			if (this.stages.length) {
				const payed = this.stages.find(el => el.invoices.length);
				if (payed) return false;
				return true;
			}
			return true;
		},

		failedStages() {
			if (
				this.status === "completed" ||
				this.status === "failed_with_payout" ||
				this.status === "archive" ||
				this.status === "failed"
			)
				return true;

			return false;
		},

    manuallyConfirmationPrice() {
      if (this.stageForCompletePaymentManually) {
        return this.stageForCompletePaymentManually.price_client
      }

      return ''
    }
	},
	methods: {
		parsePagesNumber(value) {
			return Number(String(value).replace(",", "."));
		},
		async getAuthorsOptionsByTypeValue(typeValue) {
			if (!typeValue) return [];

			if (this.authorsByTypeCache[typeValue]) {
				return this.authorsByTypeCache[typeValue];
			}

			const url = `/${this.userRole}/author?filter[type]=${typeValue}`;
			const response = await this.$http.get(url);
			const options = (response.data.data || []).map(a => ({
				...a,
				full_name: `${a.first_name} ${a.last_name}`,
			}));

			this.$set(this.authorsByTypeCache, typeValue, options);
			return options;
		},

		async onStageAuthorTypeInput(stage) {
			if (!stage || typeof stage !== "object") return;

			// Changing type alone should NOT overwrite author in DB.
			this.$set(stage, "_authorDirty", false);
			this.$set(stage, "_authorId", null);

			if (!stage._authorType) {
				this.$set(stage, "_authorsOptions", []);
				return;
			}

			const options = await this.getAuthorsOptionsByTypeValue(stage._authorType.value);
			this.$set(stage, "_authorsOptions", options);
		},

		async onStageAuthorInput(stage) {
			if (!stage || typeof stage !== "object") return;
			this.$set(stage, "_authorDirty", true);
			await this.saveStageChanges(stage);
		},

    setFailedPopupState() {
      this.failedPopupActive = true
      this.notNotifyClient = false
    },

		stageIsReadOnly(stage) {
			return (
				stage.status === "completed" ||
				stage.status === "failed_with_payout" ||
				stage.status === "failed"
			);
		},
		disableEditFieldForManager(stage) {
			if (
				this.stageIsReadOnly(stage) ||
				this.status === "archive" ||
				this.status === "deleted"
			) {
				return true;
			}
			return this.isReadOnly && !this.isEditMode;
		},

		showMarginality(stage) {
			if (this.stageIsReadOnly(stage)) {
				return false;
			}
			return true;
		},

		setStageConfirmPaymentManually(stage) {
			this.stageForCompletePaymentManually = stage;
      this.$nextTick(() => {
        this.confirmPopupState = true;
      })
		},

		async setConfirmPaymentManually(amount) {
			const stage = this.stageForCompletePaymentManually;

			try {
				await this.dbSetPaymentManually({ id: stage.id, amount });
				await this.saveStageChanges(stage);
				this.stageForCompletePaymentManually = null;
				this.$emit("updateModel");
				this.$emit("updateStages");
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		isNewStageInEditMode(stage) {
			return !stage.id && this.isEditMode;
		},

		openImagePopup(e, item) {
			this.$emit("openImagePopup", e, item);
		},

		changePopupStatus(stage) {
			this.stageItemForChange = stage;
			this.changePopupActive = true;
		},

		async updateRecommendedPrice() {
			if (this.orderId === -1) return;

			const res = await this.dbGetRecommendedPrice(this.orderId);
			this.recommendedPrice = res.price;
		},
		canManageStage(stage) {
			if (!this.currentStage) return false;

			if (
				this.currentStage.status === "in_progress" &&
				stage.id === this.currentStage.id
			)
				return true;

			return false;
		},
		canShowNotDoneButton(stage, index) {
			if (this.canManageStage(stage)) return true;
			if (
				(index !== 0 || stage.status !== "new") &&
				stage === this.currentStage
			)
				return true;
			return false;
		},
		canShowStageStatus(stage) {
			return !this.canManageStage(stage) && this.stageIsReadOnly(stage);
		},
		canShowUpload(stage) {
			if (!this.currentStage) return false;

			return (
				this.isReadOnly &&
				this.isNotUploadingPayment &&
				this.currentStage.id === stage.id &&
				(this.status === "waiting_payment" ||
					(this.currentStage === stage &&
						stage.status === "new" &&
						this.status !== "waiting_author"))
			);
		},
		sortStages() {
			this.stages.sort((a, b) => {
				const aDate = moment(a.due_date).format("YYYY-MM-DD");
				const bDate = moment(b.due_date).format("YYYY-MM-DD");

				if (aDate > bDate) return 1;
				if (aDate < bDate) return -1;
				return 0;
			});
		},
		updateStagesTypes(type) {
			if (type === null) {
				this.stages = [];
				return;
			}

			this.stages.forEach((item, index) => {
				const work = this.works.find(
					work => work.id === item.work_type_id
				);

				if (work) return;

				item.work_type_id = type;
				// this.changeStage(item, index);
			});
		},
		async addStage() {
			try {
				if (this.hasUnsavedStage) return;

				if (this.works.length === 0) {
					this.notifyError(this.$t("firstlyAddWorkTypeToOrder"));
					return;
				}

				const dueDate = this.stages.length
					? moment(
							this.stages[this.stages.length - 1].due_date
					  ).format("YYYY-MM-DD")
					: moment(new Date()).format("YYYY-MM-DD");

				const data = {
					price_client: 0,
					price_junior_middle: 0,
					price_native: 0,
					price_senior: 0,
					pages_number: 0,
					due_date: dueDate,
					work_type_id: this.works[0].id
				};

				this.stages.push(data);
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async saveStageChanges(stage) {
			if (!stage.id) return;

			if ((this.isForRecheduleReason) &&
				stage.show_reschedule_reason &&
				!stage.reschedule_reason) {
				this.rescheduleValidationError = true;
				this.notifyError(this.$t("fieldFilledIncorrect"));
				return;
			} else {
				this.rescheduleValidationError = false;
			}

			stage.invoices = stage.invoices || [];

			const data = {
				price_client: +stage.price_client,
				price_native: +stage.price_native,
				price_junior_middle: +stage.price_junior_middle,
				price_senior: +stage.price_senior,
				pages_number: this.parsePagesNumber(stage.pages_number),
				due_date: moment(stage.due_date).format("YYYY-MM-DD"),
				work_type_id: stage.work_type_id,
				files: stage.files ? stage.files.map(item => item.url) : [],
				invoices: stage.invoices ? stage.invoices.map(item => item.url) : [],
			};

			// Preserve author unless user explicitly picked/cleared it in the select.
			var existingAuthorId = null;
			if (stage.done_by_author_type && stage.done_by_author_type.id) {
				existingAuthorId = stage.done_by_author_type.id;
			} else if (stage.done_by_author_type_id) {
				existingAuthorId = stage.done_by_author_type_id;
			}

			if (stage._authorDirty) {
				data.done_by_author_type_id = stage._authorId !== undefined ? stage._authorId : null;
			} else if (existingAuthorId !== null && existingAuthorId !== undefined) {
				data.done_by_author_type_id = existingAuthorId;
			}

			data.reschedule_reason = (typeof stage.reschedule_reason === 'object' && stage.reschedule_reason !== null)
				? (stage.reschedule_reason.value || null)
				: (stage.reschedule_reason || null);

			const updated = await this.dbUpdateStage(stage.id, data);

			const idx = this.stages.findIndex(item => item.id === stage.id);
			if (idx !== -1) {
				this.$set(this.stages, idx, {
					...this.stages[idx],
					...updated,
					show_reschedule_reason: false,
					due_date_original: moment(stage.due_date).format('YYYY-MM-DD')
				});
			}
		},
		async changeStage(stage, index, isImmediate = false) {
			if (stage.work_type_id === "") {
				return;
			}

			this.stagesUpdatingList.add(stage);

			if (!isImmediate) {
				if (this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				}

				this.updateTimeout = setTimeout(() => {
					this.changeStage(stage, index, true);
					this.updateTimeout = null;
				}, 700);

				return;
			}

			const pagesNumber = this.parsePagesNumber(stage.pages_number);
			if (stage.pages_number !== "" && pagesNumber > 0) {
				stage.pages_number = pagesNumber;
				if (stage.id === undefined) {
					stage.due_date = moment(stage.due_date).format(
						"YYYY-MM-DD"
					);
					try {
						stage = await this.dbCreateStage(this.orderId, stage);
						this.stages[index].id = stage.id;
					} catch (e) {
						this.notifyError(e.message);
					}
				}
			} else {
				return;
			}

			for (let s of this.stagesUpdatingList.values()) {
				await this.saveStageChanges(s);
			}

			// this.$emit('updateStages');
			this.stagesUpdatingList.clear();

			// this.sortStages();
			await this.updateRecommendedPrice();
			// stage.pages_number = '';

			this.$emit("updateModel");
		},

		handleDueDateChange(stage) {
			const newDate = moment(stage.due_date).format('YYYY-MM-DD');
			const originalDate = moment(stage.due_date_original).format('YYYY-MM-DD');

			if (newDate !== originalDate) {
				if (this.isForRecheduleReason) {
					stage.show_reschedule_reason = true;
					stage.reschedule_reason = null;
				} else {
					stage.show_reschedule_reason = false;
					this.saveStageChanges(stage);
				}
			} else {
				stage.show_reschedule_reason = false;
			}
		},
		showRescheduleReason(stage) {
			if (!stage || typeof stage !== 'object') return false;
			if (!('reschedule_reason' in stage)) return false;
			if (!stage.reschedule_reason) return false;

			const name = this.getRescheduleReasonName(stage.reschedule_reason);
			if (!name) return false;

			return true;
		},

		getRescheduleReasonName(value) {
			if (typeof value === 'object' && value !== null && 'value' in value) {
				value = value.value;
			}

			const reason = this.rescheduleReasons.find(r => r.value === value);
			return reason ? reason.name : value || '';
		},

		async removeStage(id) {
			try {
				if (id !== undefined) {
					await this.dbRemoveStage(id);
					await this.$emit("updateModel");
				}
				const index = this.stages.findIndex(item => item.id === id);
				this.stages.splice(index, 1);
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		addPaymentPhotos(path, files) {
			this.paymentPhotos.push(files[files.length - 1]);
		},

		deletePaymentPhoto(file) {
			const index = this.paymentPhotos.findIndex(item => item === file);
			if (index !== -1) {
				this.paymentPhotos.splice(index, 1);
			}
		},

		async uploadPayment() {
			const files = this.paymentPhotos;
			if (files.length === 0) return;

			try {
				const urls = await this.dbUploadMany(files);

				const stage = this.currentStage;
				stage.invoices = stage.invoices || [];
				urls.forEach(item => stage.invoices.push(item));

				await this.changeStage(stage);

				this.paymentPhotos = [];
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		async confirmOrderWithIncorrectPrice() {
			try {
				if (!this.isPriceIncorrectTaskCreated) {
					await this.dbCreateOrderPriceTask(this.orderId);

					this.isPriceIncorrectTaskCreated = true;
				}

				if (this.marginalityPopupState) {
					return;
				}

				if (this.lowMargStage && !this.isMarginalityTaskCreated) {
					return;
				}

				await this.confirmOrder();
				this.priceIncorrectPopupState = false;
			} catch (e) {
				console.error(e);
			}
		},

		async confirmStageWithLowMarginality() {
			try {
				if (!this.isMarginalityTaskCreated) {
					await this.dbCreateMarginalityTask(this.orderId);

					this.marginalityPopupState = false;
					this.$emit("update:inputHasChanged", false);
					this.isMarginalityTaskCreated = true;
				}

				if (this.priceIncorrectPopupState) {
					return;
				}

				if (
					this.isPriceIncorrect &&
					!this.isPriceIncorrectTaskCreated
				) {
					return;
				}

				await this.confirmOrder();

				this.confirmationFunction = "";
			} catch (e) {
				console.error(e);
			}
		},

		async confirmStagePayment(id) {
			try {
				this.isNotUploadingPayment = false;
				await this.uploadPayment();

				// promise because uploadPayment long updated
				await new Promise(resolve => setTimeout(resolve, 500));

				await this.dbConfirmStagePayout(id);
				this.notifySuccess(this.$t("youConfirmedPaymentSuccessfully"));
				this.$emit("updateModel");
				this.$emit("updateStages");
				this.confirmPaymentStageId = null;
			} catch (e) {
				this.notifyError(e.message);
			}

			this.isNotUploadingPayment = true;
		},

		async sendOrderApproval() {
			this.isLoading = true;

			try {
				await this.dbSendOrderApproval(this.orderId);
				this.notifySuccess(this.$t("dataWasSentToClientForApproval"));

				this.$emit("updateModel");
			} catch (e) {
				this.notifyError(e.message);
			} finally {
				this.isLoading = false;
			}
		},

		checkMarginalityBeforeConfirmOrder() {
			if (
				this.isPriceIncorrect &&
				!this.isPriceIncorrectTaskCreated &&
				this.lowMargStage &&
				!this.isMarginalityTaskCreated
			) {
				this.priceIncorrectPopupState = true;
				this.marginalityPopupState = true;
				this.confirmationFunction = "confirmOrder";
			} else if (
				this.isPriceIncorrect &&
				!this.isPriceIncorrectTaskCreated
			) {
				this.priceIncorrectPopupState = true;
			} else if (this.lowMargStage && !this.isMarginalityTaskCreated) {
				this.marginalityPopupState = true;
				this.confirmationFunction = "confirmOrder";
			} else {
				this.confirmOrder();
			}
		},

		confirmOrder() {
			this.isLoading = true;

			const callback = () => (this.isLoading = false);
			this.$emit("confirmOrder", callback);

			this.isPriceIncorrectTaskCreated = false;
			this.isMarginalityTaskCreated = false;
		},

		async setStageDone(authorAward, closureStatus, comment) {
			const userId = this.$store.state.auth.user.user_id

			try {
			  this.isLoading = true;
				await this.dbSetStageDone(this.currentStage.id, authorAward, this.notNotifyClient, closureStatus, comment, this.orderId, userId);
				this.notifySuccess(
					`${this.$t("youMarkedStageAs")} "${this.$t("completed")}"`
				);
				this.$emit("updateModel");
				this.$emit("updateStages");
        this.donePopupActive = false
        this.notNotifyClient = false
			} catch (e) {
				this.notifyError(e.message);
			} finally {
			  this.isLoading = false
      }
		},

		async setStageFailed(reasonData, amount, comment, caused_by, userId) {
			try {
				this.isLoading = true;

				const numericAmount = amount ? parseFloat(amount) : 0;

				if (reasonData.is_payout === 1) {
					await this.dbSetStageFailedWithPayout(
						this.currentStage.id,
						reasonData.reason_id,
						numericAmount,
						this.notNotifyClient,
						comment,
						caused_by,
						userId
					);
				} else {
					await this.dbSetStageFailed(
						this.currentStage.id,
						reasonData.reason_id,
						this.notNotifyClient,
						comment,
						caused_by,
						userId
					);
				}

				this.notifyDanger(
					`${this.$t("youMarkedStageAs")} "${this.$t("failed")}"`
				);
				this.$emit("updateModel");
				this.$emit("updateStages");
				this.failedPopupActive = false;
				this.notNotifyClient = false;

			} catch (e) {
				this.notifyError(e.message);
			} finally {
				this.isLoading = false;
			}
		},

		async setStageChanged(stage) {
			try {
				let currentStage = this.currentStage;
				const data = {
					price_junior_middle: +stage.price_junior_middle,
					price_senior: +stage.price_senior
				};
				if (this.userRole === "admin") {
					await this.updatePaymentPrice(stage.id, stage.price_client);
					currentStage = stage;
				}
				if (!this.stageIsReadOnly(stage)) {
					await this.dbUpdateStagePrice(currentStage.id, data);
				}
				this.notifySuccess(`${this.$t("priceChangedSuccessfully")}`);
				this.$emit("updateModel");
				this.$emit("updateStages");
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		async updatePaymentPrice(id, amount) {
			try {
				await this.dbUpdatePaymentPrice(id, amount);
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		async enableEditing() {
			this.isEditClicked = true;

			try {
				await this.dbBackOrderToProcess(this.orderId);
				this.notifySuccess(
					`${this.$t("stageWasMovedToStatus")} "${this.$t(
						"processing"
					)}"`
				);
				this.$emit("updateModel");
				this.$emit("updateStages");
			} catch (e) {
				this.notifyError(e.message);
			}

			this.isEditClicked = false;
		},

		setStagesPrices(id) {
			return this.enableWorkTypesList.find(el => el.work_type_id === id);
		},

		updateStage: debounce(async function(stage, index, inputVal) {
			this.$emit("update:inputHasChanged", true);

			try {
				await this.recalculatePrices(stage, inputVal, true);
				await this.changeStage(stage, index);

				this.isMarginalityTaskCreated = false;
			} catch (err) {
				console.error(err);
			}
		}, 300),

		async recalcPriceAndChangeStage(stage, index, inputVal) {
			await this.recalculatePrices(stage, inputVal);
			await this.changeStage(stage, index);
		},

		async recalculatePrices(stage, inputVal, forceUpdate = false) {
			if (
				(!(!this.isNewStageInEditMode(stage) && !this.isEditMode) ||
					this.isReadOnly ||
					this.stageIsReadOnly(stage)) &&
				!forceUpdate
			)
				return;

			if (inputVal !== "" && inputVal !== undefined) return;

			try {
				const prices = this.setStagesPrices(stage.work_type_id);

				let subjectPrice = 0;
				if (
					this.currentSubject &&
					this.currentSubject.additionalPrice &&
					([3,4,6].indexOf(stage.work_type_id) === -1)
				) {
					subjectPrice = this.currentSubject.additionalPrice;

				}
				let clientPrice = stage.price_client;
				const clientRecommend = this.works.find(
					el => el.id === stage.work_type_id
				);

				if (clientRecommend && !this.isReadOnly) {
					clientPrice = Math.round(
						(stage.pages_number *
							clientRecommend.recommendedPrice) /
							clientRecommend.pages
					);
					this.$set(stage, "price_client", clientPrice);
				}

				if (prices) {
					this.$set(
						stage,
						"price_junior_middle",
						Math.round(
							(prices.middle_price + subjectPrice) *
								stage.pages_number
						)
					);
					this.$set(
						stage,
						"price_senior",
						Math.round(
							(prices.senior_price + subjectPrice) *
								stage.pages_number
						)
					);
				}
				if (this.isNativeAuthor) {
					this.$set(
						stage,
						"price_native",
						this.isNativeAuthor * stage.pages_number
					);
				}
			} catch (e) {
				this.notifyError(e);
			}
		},
		async updateAllPrices() {
			for (const stage of this.stages) {
				await this.recalculatePrices(stage);
				await this.changeStage(stage);
			}
		},
		checkIsNativeAuthorHasPrice() {
			if (!this.stages.length) {
				return;
			}

			this.stages.forEach(async stage => {
				if (stage.id && stage.price_native === 0) {
					this.$set(
						stage,
						"price_native",
						this.isNativeAuthor * stage.pages_number
					);
					await this.saveStageChanges(stage);
				}
			});
		},
		publicType(type) {
			const mapping = {
				'author': 'Author',
				'ki-author': 'KI-Author',

			};
			return mapping.hasOwnProperty(type) ? mapping[type] : 'Author';
		},
	},
	mounted() {
		this.updateRecommendedPrice();
	}
};
</script>

<style lang="scss">
.ticket-payment-info {
	.stage {
		border-bottom: 1px solid #e4e4e4;
		padding: 15px 0;

		&.not_paid {
			background: rgba(255, 171, 93, 0.55);
			border-radius: 10px;
			padding: 10px;
		}

		&__control {
			padding: 7px 10px !important;
		}

		.manual-payout {
			transition: box-shadow ease 0.2s;
			&:hover {
				box-shadow: 0px 0px 4px 2px #278e55;
			}
		}

		.head {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center;
			grid-row-gap: 10px;
			grid-column-gap: 10px;
		}
		.validation-star {
			color: rgba(255, 255, 255, 0.6);
		}
		&__title {
			font-size: 18px;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			grid-column-gap: 10px;

			&-marginality {
				border-radius: 4px;
				padding: 0 5px;
				font-size: 15px;
			}
		}

		&-list {
			.vs-input {
				width: 100%;
			}

			&__item {
				display: flex;
				align-items: flex-end;
				margin-top: 8px;

				.vs-input--label {
					display: flex;
				}
			}
		}

		&__invoice {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #e3e3e3;
			width: 200px;
			height: 200px;
			border-radius: 8px;
			margin-top: 20px;
			cursor: pointer;

			img {
				max-width: 100%;
				max-height: 100%;
			}
		}

		&-info {
			display: flex;
			justify-content: space-between;
			width: 100%;
		}

		.vs__search {
			background: inherit;
		}
		.vs__open-indicator {
			background: inherit;
		}

		.date-picker {
			// kostyl'
			&.additional-class {
				@media screen and (max-width: 2096px) {
					.vdp-datepicker__calendar {
						right: -40%;
					}
				}

				@media screen and (max-width: 1920px) {
					.vdp-datepicker__calendar {
						right: -45%;
					}
				}

				@media screen and (max-width: 1600px) {
					.vdp-datepicker__calendar {
						right: -50%;
					}
				}

				@media screen and (max-width: 1420px) {
					.vdp-datepicker__calendar {
						right: -70%;
					}
				}

				@media screen and (max-width: 998px) {
					.vdp-datepicker__calendar {
						right: -30%;
					}
				}
			}
		}
	}
}
</style>
